// One-shot gate for the map drag-hint compass. The map re-mounts on every
// phase change (each phase UI renders its own MapView), so a MapView-local
// "shown" flag would re-fire the hint each phase. Instead the game screen ARMS
// this module-level flag once when it mounts (per game id), and MapView
// CONSUMES it on the first zoom-in — so the NSWE drag compass shows at most
// once per screen visit. Navigating away and back re-mounts the screen, which
// re-arms it, so the hint shows again on the next visit.
let armed = false

/** Arm the hint so the next zoom-in shows the drag compass once. */
export function armDragHint(): void {
  armed = true
}

/** Returns true (and disarms) if the hint is armed — call on a zoom-in. */
export function consumeDragHint(): boolean {
  if (!armed) return false
  armed = false
  return true
}
